"use strict";

var _toArray = require("/codebuild/output/src073659321/src/turo-project/turo-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toArray");

var _slicedToArray = require("/codebuild/output/src073659321/src/turo-project/turo-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/codebuild/output/src073659321/src/turo-project/turo-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src073659321/src/turo-project/turo-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var fromRaw_1 = __importDefault(require("../serialize/fromRaw"));

var id_1 = __importDefault(require("./id"));

var change_1 = __importDefault(require("../change/change"));

var fromText_1 = __importDefault(require("../serialize/fromText"));

var change_2 = require("../change");

var emptyList = {
  value: [],
  entityMap: {}
};

var EditorState =
/*#__PURE__*/
function () {
  function EditorState(_ref) {
    var _ref$start = _ref.start,
        start = _ref$start === void 0 ? 0 : _ref$start,
        _ref$end = _ref.end,
        end = _ref$end === void 0 ? 0 : _ref$end,
        anchorOffset = _ref.anchorOffset,
        focusOffset = _ref.focusOffset,
        _ref$list = _ref.list,
        list = _ref$list === void 0 ? emptyList : _ref$list,
        _ref$lastChangeType = _ref.lastChangeType,
        lastChangeType = _ref$lastChangeType === void 0 ? null : _ref$lastChangeType,
        _ref$currentStyles = _ref.currentStyles,
        currentStyles = _ref$currentStyles === void 0 ? [] : _ref$currentStyles,
        _ref$undoStack = _ref.undoStack,
        undoStack = _ref$undoStack === void 0 ? [] : _ref$undoStack,
        _ref$redoStack = _ref.redoStack,
        redoStack = _ref$redoStack === void 0 ? [] : _ref$redoStack;

    _classCallCheck(this, EditorState);

    this.redoStack = [];
    this.undoStack = [];
    this.list = list;
    this.undoStack = undoStack;
    this.currentStyles = currentStyles;
    this.anchorOffset = typeof anchorOffset === 'number' ? anchorOffset : start;
    this.focusOffset = typeof focusOffset === 'number' ? focusOffset : end;

    var _sort = [this.anchorOffset, this.focusOffset].sort(function (a, b) {
      return a - b;
    }),
        _sort2 = _slicedToArray(_sort, 2),
        _start = _sort2[0],
        _end = _sort2[1];

    this.start = _start;
    this.end = _end;
    this.lastChangeType = lastChangeType;
    this.redoStack = redoStack;
  }

  _createClass(EditorState, [{
    key: "change",
    value: function change(_change) {
      var start = (typeof _change.start === 'number' ? _change.start : this.start) + 1;
      var end = (typeof _change.end === 'number' ? _change.end : this.end) + 1;
      var defaultChange = {
        start: this.start,
        end: this.end,
        value: this.list.value.slice(start, end)
      };
      var update = {
        current: this.list,
        change: Object.assign({}, defaultChange, _change)
      };
      var updated = change_1.default(update);
      var undoStack = this.undoStack;

      var _this$undoStack = _toArray(this.undoStack),
          lastUndo = _this$undoStack[0],
          undoRest = _this$undoStack.slice(1);

      var lastChangeType = _change.type || null;

      if (Boolean(_change.isBoundary) === false || this.undoStack.length === 0) {
        undoStack = [[updated.change].concat(lastUndo || [])].concat(undoRest);
      } else {
        undoStack = [[updated.change]].concat([lastUndo || []].concat(undoRest));
      }

      return new EditorState({
        start: updated.change.start - 1,
        end: updated.change.end - 1,
        currentStyles: this.currentStyles,
        lastChangeType: lastChangeType,
        list: updated.current,
        redoStack: [],
        undoStack: undoStack
      });
    }
  }, {
    key: "createEntity",
    value: function createEntity(entity) {
      var entityKey = id_1.default();
      this.list.entityMap[entityKey] = entity;
      return entityKey;
    }
  }, {
    key: "undo",
    value: function undo() {
      return change_2.undo(this);
    }
  }, {
    key: "redo",
    value: function redo() {
      return change_2.redo(this);
    }
  }, {
    key: "setCurrentStyles",
    value: function setCurrentStyles(styles) {
      this.currentStyles = styles;
      return this;
    }
  }, {
    key: "toggleStyle",
    value: function toggleStyle(style) {
      var _start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.start;

      var _end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.end;

      var start = _start + 1;
      var end = _end + 1;
      var selectedValue = this.list.value.slice(start, end);
      var hasStyle = selectedValue.every(function (char) {
        return char.type != null || char.styles.includes(style);
      });
      var updatedValue = selectedValue.map(function (char) {
        var newChar = Object.assign({}, char);

        if (newChar.type == null) {
          if (hasStyle) {
            newChar.styles = newChar.styles.filter(function (st) {
              return st !== style;
            });
          } else if (!newChar.styles.includes(style)) {
            newChar.styles = newChar.styles.concat([style]);
          }
        }

        return newChar;
      });
      var newEditorState = this.change({
        isBoundary: true,
        value: updatedValue
      });
      newEditorState.start = _start;
      newEditorState.end = _end;

      if (!hasStyle || !this.currentStyles.includes(style)) {
        newEditorState.currentStyles = newEditorState.currentStyles.concat([style]);
      } else {
        newEditorState.currentStyles = newEditorState.currentStyles.filter(function (st) {
          return st !== style;
        });
      }

      return newEditorState;
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(json) {
      return new EditorState({
        list: fromRaw_1.default(json)
      });
    }
  }, {
    key: "fromText",
    value: function fromText(text) {
      return new EditorState({
        list: fromText_1.default(text)
      });
    }
  }]);

  return EditorState;
}();

exports.default = EditorState;